import clsx from "clsx";
import styles from "./index.module.scss";

export default function Checkbox({ onChange, checked, label, count }) {
  return (
    <div
      className={clsx(checked && styles.CheckboxChecked, styles.Checkbox)}
      onClick={onChange}
    >
      <div className={styles.Box}>
        {checked && (
          <svg
            width="18"
            height="13"
            viewBox="0 0 18 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17 1L6 12L1 7"
              stroke="#9DA4AE"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
      <span className={styles.Label}>{label}</span>
      {count && <span className={styles.Count}>{count}</span>}
    </div>
  );
}
